import styled from 'styled-components';

const Wrapper = styled.div`
  .dashboard-widget-picker {
    display: flex;
    flex-direction: column;
    width: 220px;
    margin-top: 44px;
    background: ${(props) => props.theme.colors.widget_background};
    box-shadow: ${(props) => props.theme.shadows.dropdown};
    border-radius: 12px;
    overflow: hidden;

    li {
      width: 100%;

      button {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        padding: 14px 16px;
        color: ${(props) => props.theme.colors.text};
        font-family: ManropeBold, sans-serif;
        font-size: 13px;
        cursor: pointer;

        &:hover {
          background: ${(props) => props.theme.colors.inactive};
        }
      }
    }
  }
`;

export default { Wrapper };
